import React from 'react';
import PropTypes from 'prop-types';
import usePrevious from '@afosto/utils-react/component/usePrevious';
import TextField from '../TextField';
import NumberFormat from 'react-number-format';

const CurrencyFormat = props => {
  const { inputRef, onChange, value, name, formatOptions = {}, ...other } = props;
  const {
    thousandSeparator = '.',
    decimalSeparator = ',',
    decimalScale = 2,
    fixedDecimalScale = true,
    prefix = '€',
    isNumericString = true,
  } = formatOptions;
  const oldValue = usePrevious(value);

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      name={name}
      value={(value && value !== '') || value === 0 ? parseInt(value, 10) / 100 : null}
      onValueChange={values => {
        const newValue = values?.floatValue ? Math.round(values.floatValue * 100) : 0;

        if (oldValue !== newValue) {
          onChange({
            target: {
              value: newValue,
              name,
            },
          });
        }
      }}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      prefix={prefix}
      isNumericString={isNumericString}
    />
  );
};

CurrencyFormat.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  formatOptions: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
};

CurrencyFormat.defaultProps = {
  formatOptions: {},
  value: null,
  name: '',
};

const CurrencyField = ({ InputProps, ...props }) => (
  <TextField
    {...props}
    InputProps={{
      ...InputProps,
      inputComponent: CurrencyFormat,
    }}
  />
);

CurrencyField.propTypes = {
  InputProps: PropTypes.object,
};

CurrencyField.defaultProps = {
  InputProps: {},
};

export default CurrencyField;
